import React from "react";
import "./Basic.css"; // Assuming you have a CSS file for styling

const Basic = () => {
  return (
    <div>

       <section className="common-page-hero">
  <img src="assets/img/service/mw7.png" className="common-hero-bg ak-bg" alt="Background" />

  <div className="common-hero-content">
    <div className="common-hero-info">
      <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">

        {/* Sub Title */}
        <p className="ak-section-subtitle animation-title" style={{ perspective: "400px", textAlign: "center" }}>
          <span className="split-line">Courses</span>
        </p>

        {/* Mini Title */}
        <p className="mini-title1" style={{
          backgroundColor: "#e87722",
          color: "white",
          padding: "5px 10px",
          fontWeight: "bold",
          display: "inline-block",
          borderRadius: "5px"
        }}>
          SEMANTIC Skills Junction
        </p>

        {/* Main Title */}
        <h2 className="ak-section-title animation-title" style={{ fontSize: "45px", perspective: "400px", textAlign: "center" }}>
          <div className="split-line">
            <span>SEMANTIC</span> <span>Skills</span> <span>Junction:</span> <span>Bridging</span>
          </div>
          <div className="split-line">
            <span>Talent</span> <span>and</span> <span>Technology</span>
          </div>
        </h2>
      </div>

      <p className="back-btn">
        <a href="/">Home</a> / Course
      </p>

    </div>
    <a href="tel:+917619617023" className="phone-number">(+91) 7619617023</a>
  </div>
</section>

  
      <div class="course-container">
        <div class="header">
          <h1 class="title">Basics and Conceptual Courses</h1>
          <div class="program-info">
            <h2 class="info-title">Program Information</h2>
            <ul class="program-info-list">
              <li class="program-info-item">
                Short Term Programmes (0.5 day to 1 day)
              </li>
              <li class="program-info-item">
                Industry Case Studies and Videos included to enhance
                participants comprehension
              </li>
              <li class="program-info-item">
                Can be offered onsite if required
              </li>
            </ul>
          </div>
        </div>
        <div class="courses-grid">
          <div class="course-card">
            <h3 class="course-title">Semiconductor Industry and Ecosystem</h3>
            <p class="course-description">
              Comprehensive overview of the semiconductor industry structure and
              relationships
            </p>
            <span class="category-tag">Industry Overview</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Introduction to Semiconductor Manufacturing
            </h3>
            <p class="course-description">
              Fundamentals of semiconductor manufacturing processes and
              technologies
            </p>
            <span class="category-tag">Manufacturing</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Introduction to Wafer Fabrication</h3>
            <p class="course-description">
              Basic principles and processes of wafer fabrication
            </p>
            <span class="category-tag">Fabrication</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Introduction to Semiconductor Packaging
            </h3>
            <p class="course-description">
              Fundamentals of semiconductor packaging technologies
            </p>
            <span class="category-tag">Packaging</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Advanced Semiconductor Packaging</h3>
            <p class="course-description">
              Advanced packaging technologies and future trends
            </p>
            <span class="category-tag">Advanced Packaging</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Semiconductor World for non-Engineers</h3>
            <p class="course-description">
              Simplified approach to understanding semiconductor technology
            </p>
            <span class="category-tag">Fundamentals</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Moore's Law and Dennard Scaling</h3>
            <p class="course-description">
              Understanding key principles driving semiconductor advancement
            </p>
            <span class="category-tag">Technology Driver</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Advanced Scaling, Technology evolution, FinFETs, Ultra-thin Body
              SOI
            </h3>
            <p class="course-description">
              Modern semiconductor scaling techniques and technologies
            </p>
            <span class="category-tag">Advanced Technology</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Silicon Wafers</h3>
            <p class="course-description">
              Detailed study of silicon wafer properties and manufacturing
            </p>
            <span class="category-tag">Materials</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Cleanrooms</h3>
            <p class="course-description">
              Cleanroom technology and contamination control
            </p>
            <span class="category-tag">Infrastructure</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">CMOS Process Integration</h3>
            <p class="course-description">
              Integration of various CMOS manufacturing processes
            </p>
            <span class="category-tag">Process Integration</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">More than Moore Technologies</h3>
            <p class="course-description">
              Beyond traditional scaling approaches in semiconductor technology
            </p>
            <span class="category-tag">Beyond Miniaturization</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">MOSFET Physics and Reliability</h3>
            <p class="course-description">
              Understanding MOSFET operation and reliability concerns
            </p>
            <span class="category-tag">Device Physics</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">Manufacturing Execution System [MES]</h3>
            <p class="course-description">
              Overview of manufacturing execution systems in semiconductor
              production
            </p>
            <span class="category-tag">Systems</span>
          </div>
          <div class="course-card">
            <h3 class="course-title">
              Manufacturing Quality Assurance overview
            </h3>
            <p class="course-description">
              Introduction to quality assurance in semiconductor manufacturing
            </p>
            <span class="category-tag">Quality</span>
          </div>
        </div>
      </div>
   
   </div>
  );
};

export default Basic;
